import type { Product, VariantSelection } from '../types/product';
import { products } from '../data/products';

export function getProduct(id: string | undefined): Product | undefined {
  return products.find((p) => p.id === id);
}

export function defaultSelection(product: Product): VariantSelection {
  const sel: VariantSelection = {};
  product.variants?.forEach((g) => {
    sel[g.id] = g.options[0].id;
  });
  return sel;
}

export function resolveVariant(product: Product, selection: VariantSelection) {
  let delta = 0;
  let image = product.image;
  let capacityWh = product.capacityWh;
  const labels: string[] = [];

  product.variants?.forEach((g) => {
    const opt = g.options.find((o) => o.id === selection[g.id]) ?? g.options[0];
    delta += opt.priceDelta;
    if (opt.image) image = opt.image;
    if (opt.capacityWh) capacityWh = opt.capacityWh;
    labels.push(opt.label);
  });

  const key = `${product.id}:${product.variants?.map((g) => selection[g.id]).join('-') ?? 'base'}`;

  return {
    key,
    price: Math.round((product.price + delta) * 100) / 100,
    compareAt: product.compareAt ? product.compareAt + delta : undefined,
    image,
    capacityWh,
    labels,
  };
}

export function discountPercent(product: Product): number {
  return product.compareAt ? Math.round((1 - product.price / product.compareAt) * 100) : 0;
}
